module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-f143bbf1.png";